import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 19H13V13H19V19ZM11 19H5V13H11V19ZM19 11H13V5H19V11ZM11 11H5V5H11V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "GridBig"
);
